import {useEffect, useState} from "react"

import Grid from '@material-ui/core/Grid'

import Dialog from "@base/Dialog";
import TextField from '@base/Inputs/Text/TextField'
import SelectOption from '@base/Inputs/Select/Select'
import EscolaService from '@services/EscolaService'
import VisualizadorDeArquivo from '@base/VisualizadorDeArquivo';
import CircularProgress from '@material-ui/core/CircularProgress'
import ButtonPrimary from "../../base/Button/Button";

import useStatusPendencia from '@hooks/enums/useStatusPendencia';
/* import useOrigemProblema from '@hooks/enums/useOrigemProblema'; */

export const TratamentoNomeDialog = (props) => {
  const processo = props.processo;
  
  const listagemStatus = useStatusPendencia();/* 
  const listagemOrigemProblema = useOrigemProblema(); */

  const [, setFormId] = useState("");
  const [formTratamentoStatus, setFormTratamentoStatus] = useState("");
  const [formOrigemProblema, setFormOrigemProblema] = useState("");
  const [formOrigemProblemaOutro, setFormOrigemProblemaOutro] = useState("");
 /*  const [formTratamentoEscola, setFormTratamentoEscola] = useState(""); */
  const [, setFormTratamentoCartaoId] = useState("");
 /*  const [formTratamentoCartao, setFormTratamentoCartao] = useState(""); */
  const [formTratamentoNome, setFormTratamentoNome] = useState("");
  const [formTratamentoPendencia, setFormTratamentoPendencia] = useState("");
const [blob, setBlob] = useState();
 const [loading, setLoading] = useState(false);
  const buttonsSubmit = () => !loading ?
    <><div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
      {/* <ButtonSave  onClick={() => tratarPendencia()} /> */}
      <ButtonPrimary
          onClick={() =>  tratarPendencia("SEM_PROBLEMA")}
          name="Resolvida - sem problema"
          disabled={loading}
          style={{backgroundColor: '#20752b', marginRight: "1rem"}}
        />
         <ButtonPrimary
          onClick={() => tratarPendencia("DIGITACAO")}
          name="Resolvida - Erro Digitação"
          disabled={loading}
          style={{backgroundColor: '#d98507', marginRight: "1rem"}}
        />
        <ButtonPrimary
          onClick={() => tratarPendencia("ESCOLA")}
          name="Resolvida - Erro Escola"
          disabled={loading}
          style={{backgroundColor: '#d98507', marginRight: "1rem"}}
        />
        <ButtonPrimary
          onClick={() => tratarPendencia("DIGITALIZACAO")}
          name="Resolvida - Erro Digitalização"
          disabled={loading}
          style={{backgroundColor: '#d98507', marginRight: "1rem"}}
        />

      <ButtonPrimary
          onClick={() => descartar()}
          name="Descartar Cartão"
          disabled={loading}
          style={{backgroundColor: '#ad3a32', marginRight: "1rem"}}
        />

       </div>
    </>
    : <><CircularProgress size={16} />  Aguarde...</>

    const descartar = () => {

      setLoading(true);
     let obj = {};
    obj.motivo = "TRATAMENTO_NOME";
  
      EscolaService.descartarCartao(props.processo, props.id, obj).then(resultado => {
        props.handleClose();
        props.handleSave({
          "data" : { 
            "id" :  props.id
          }
        });
        props.toastReference.current.show("success", "Cartão descartado com sucesso.");
      });
  
    }

  const tratarPendencia = (origem) => {
	setLoading(true);
 
  let obj = {
      status: origem ? "RESOLVIDA" : formTratamentoStatus === "" ? undefined : formTratamentoStatus,
      nomeSubstituto: formTratamentoNome,
      origemProblema: origem ? origem : formOrigemProblema === "" ? undefined : formOrigemProblema,
      descricaoOrigemOutro: formOrigemProblemaOutro === "" ? undefined : formOrigemProblemaOutro
    };

    
    EscolaService.atualizarStatusTratamentoNome(props.processo, props.id, obj).then(resultado => {
      props.handleClose();
      props.handleSave(resultado);
      props.toastReference.current.show("success", "Nome tratado com sucesso.");
      
	    setLoading(false);
    }).catch(error => { props.toastReference.current.show("error", "Erro" + error.response.data.mensagens.map(mensagem => mensagem).join(" ,")); setLoading(false); });
  }


  const limparEstado = () => {
    setFormId("");
    setFormTratamentoStatus("");
    setFormTratamentoPendencia("");

   /*  setFormTratamentoEscola(""); */
/*     setFormTratamentoCartao(""); */
    setFormTratamentoCartaoId("");
    setFormTratamentoNome("");
  }

  useEffect(() => {
    setFormId(props.id);
  }, [props.id]);

  useEffect(() => {
    if (props.id) {

		EscolaService.downloadArquivoCartao(processo, undefined, props.id).then(resposta => {
				setBlob(resposta.data);
		});

		EscolaService.buscaDadosDoCartao(processo, props.id).then(resposta => {

			let pendencia = resposta;

		    if (pendencia.data.tratamentoNome) {
		      setFormTratamentoStatus(pendencia.data.tratamentoNome.status);
		      setFormTratamentoPendencia(pendencia.data.tratamentoNome.tipo);
		      setFormOrigemProblema(pendencia.data.tratamentoNome.origem);
		      setFormOrigemProblemaOutro(pendencia.data.tratamentoNome.descricaoOrigemOutro);
		    }

		   /*  setFormTratamentoEscola(pendencia.data.escola); */
		/*     setFormTratamentoCartao(pendencia.data.codigo); */
		    setFormTratamentoCartaoId(pendencia.data.id);
		    setFormTratamentoNome(pendencia.data.nomeAluno);
      	});


    }
  }, [ processo, props.id, props.codigo]);

  return (
    <>
      <Dialog
        maxWidth={"lg"}
        fullWidth={true}
        closeDialog={() => { limparEstado(); props.handleClose(); }}
        openDialog={props.open}
        title="Tratar Nome"
        actions={buttonsSubmit()}
      >

		<Grid container spacing={3}>
			<Grid item sm={4}>
		     {/*    <Grid container spacing={3}>
		          <Grid item sm={12}>
		            <TextField disabled label="Escola" value={formTratamentoEscola} />
		          </Grid>
				</Grid>
				<Grid container spacing={3}>
		          <Grid item sm={12}>
		            <TextField disabled label="Código do Cartão" value={formTratamentoCartao} />
		          </Grid>
		        </Grid> */}

		        <Grid container spacing={3}>
		          <Grid item sm={12}>
		            <TextField disabled label="Pendência" value={formTratamentoPendencia} />
		          </Grid>
				</Grid>
				<Grid container spacing={3}>
		          <Grid item sm={12}>
		            <SelectOption
		              label='Status'
		              required
                  disabled
		              value={formTratamentoStatus}
		              name='formTratamentoStatus'
		              onChange={(e) => setFormTratamentoStatus(e.target.value)}
		              options={listagemStatus.data}
		            />
		          </Grid>
		        </Grid>

		        <Grid container spacing={3}>
		         {/*  <Grid item sm={12}>
		            <SelectOption
		              label='Origem do Problema'
		              required={formTratamentoStatus === 'RESOLVIDA' ? true : false}
		              value={formOrigemProblema}
		              name='formOrigemProblema'
		              onChange={(e) => setFormOrigemProblema(e.target.value)}
		              options={listagemOrigemProblema.data}
		            />
		          </Grid> */}
				</Grid>
				<Grid container spacing={3}>
		          {formOrigemProblema === "OUTRO" &&
		            <Grid item sm={12}>
		              <TextField label="Qual foi o problema?" value={formOrigemProblemaOutro} onChange={(e) => setFormOrigemProblemaOutro(e.target.value)} />
		            </Grid>
		          }
		        </Grid>

		        <Grid container spacing={3}>
		          <Grid item sm={12}>
		            <TextField label="Nome do Aluno" value={formTratamentoNome} onChange={(e) => setFormTratamentoNome(e.target.value)} />
		          </Grid>
		        </Grid>
			</Grid>
			<Grid item sm={8}>
				{blob ? <VisualizadorDeArquivo

								blob={blob}
							/>
					 : <CircularProgress size={16} />}
			</Grid>
		</Grid>

      </Dialog>
    </>
  );
}

export default TratamentoNomeDialog;
